export const OVERVIEW_RUNS_POLL_MS = 10_000;
export const OVERVIEW_RUNS_LAST_HOURS = 24;
export const OVERVIEW_RUNS_LIMIT = 50;
export const OVERVIEW_RECENT_TAKE = 5;
